import { Box, TextField } from '@iheartjane/reefer';
import { useState } from 'react';

import {
  useDeleteMedicalIdNumber,
  useUpdateMedicalIdNumber,
} from '@jane/shared/data-access';

import { useCustomerDispatch } from '../../customer/dispatch';
import {
  selectIdentification,
  setIdentificationValue,
} from '../../customer/redux/identification';
import { useCustomerSelector } from '../../customer/selectors';
import styles from './mmjIdentification.module.css';
import { WarningMessage } from './warningMessage';

export const MedicalIdNumberIdentification = () => {
  const { document } = useCustomerSelector(selectIdentification);
  const dispatch = useCustomerDispatch();
  const { mutate } = useUpdateMedicalIdNumber();
  const { mutate: deleteMedicalIdNumber } = useDeleteMedicalIdNumber();
  const [medicalIdNumber, setMedicalIdNumber] = useState(
    document.mmj_card_id_number || ''
  );

  const persistMedicalIdNumber = (value = '') => {
    if (value === (document.mmj_card_id_number || '')) return;

    const onSuccess = () =>
      dispatch(setIdentificationValue({ name: 'mmj_card_id_number', value }));

    // The backend rejects a blank id_number (presence validation), so clearing
    // the field removes the stored number via DELETE rather than a PATCH.
    if (value) {
      mutate(value, { onSuccess });
    } else {
      deleteMedicalIdNumber(undefined, { onSuccess });
    }
  };

  return (
    <Box className={styles['medicalNumberIdentification']}>
      <TextField
        aria-invalid={!document.mmj_card_id_number}
        label="Medical ID number"
        name="medical-id-number"
        onBlur={persistMedicalIdNumber}
        onChange={setMedicalIdNumber}
        value={medicalIdNumber}
        disableMobileInputStyling
      />
      {!document.mmj_card_id_number && (
        <Box mt={8}>
          <WarningMessage>ID required for discount</WarningMessage>
        </Box>
      )}
    </Box>
  );
};
